import styled from "styled-components";

export const FooterActionsContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;

    padding: 25px;
    border-top: 1px solid #ebedf2;

    & > div {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 6px;

        &:nth-child(3n + 2) {
            justify-content: center;
        }

        &:nth-child(3n + 3) {
            justify-content: flex-end;
        }
    }

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
        row-gap: 6px;

        & > div {
            &:nth-child(3n + 2) {
                justify-content: flex-start;
            }

            &:nth-child(3n + 3) {
                justify-content: flex-start;
            }
        }
    }
`
